import { type ButtonHTMLAttributes, forwardRef } from "react";
import { twMerge } from "tailwind-merge";

export type KemCitationPillProps = Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  "children"
>;

const KemCitationPill = forwardRef<HTMLButtonElement, KemCitationPillProps>(
  ({ className, onPointerDown, type: _type, ...props }, ref) => (
    <button
      ref={ref}
      type="button"
      {...props}
      className={twMerge(
        "rounded-full border border-gray-200 bg-white px-2.5 py-1 text-sm font-medium text-black shadow-sm transition-colors hover:border-gray-300 hover:bg-gray-50",
        className,
      )}
      onPointerDown={(event) => {
        event.stopPropagation();
        onPointerDown?.(event);
      }}
    >
      Citations
    </button>
  ),
);

KemCitationPill.displayName = "KemCitationPill";

export default KemCitationPill;
